"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILButton = void 0;
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var enums_1 = require("../../shared/enums");
var ILButton = function (props) {
    var sx = props.sx;
    return (react_1.default.createElement(Button_1.default, __assign({ 
        // defaults
        size: enums_1.SizeEnum.MEDIUM,
        variant: enums_1.ButtonVariantEnum.CONTAINED,
        disabled: false,
        color: enums_1.ColorPaletteEnum.PRIMARY,
        className: props.active ? 'active' : '',
        sx: __assign({ borderRadius: '25px', boxShadow: '0 3px 3px 0 rgba(0, 33, 53, 0.1)', width: '200px', height: '40px', fontSize: '13px', '&:hover': {
                backgroundColor: 'action.hover',
            } }, sx) }, props, { 
        // prevent render to dom
        active: undefined }), props.children));
};
exports.ILButton = ILButton;
